import React from "react";

import { ComboBox, Item } from "@react-spectrum/combobox";

import { Provider } from "@react-spectrum/provider";

import { theme } from "@react-spectrum/theme-default";

interface Props {
  options: Iterable<object>;
  placeHolder: string;
  onSelectionChange: (id: number) => void;
  label: string;
}

const Combobox = (props: Props) => {
  const { options, placeHolder, onSelectionChange, label } = props;

  return (
    <>
      <Provider theme={theme} colorScheme="light">
        <div style={{ background: "white" }}>
          <ComboBox
            label={label}
            defaultItems={options}
            onSelectionChange={onSelectionChange}
            placeholder={placeHolder}
          >
            {(item: { id: string; name: string }) => (
              <Item key={item.id}>{item.name}</Item>
            )}
          </ComboBox>
        </div>
      </Provider>
    </>
  );
};

export default Combobox;
